export enum FormFieldType {
  TextField = 'textfield',
  Select = 'select',
  TextDisplay = 'textDisplay',
  Checkbox = 'checkbox',
  CheckboxDisplay = 'checkboxDisplay',
  Nested = 'nested',
}
